import UserPasswordFormContainer from './containers/UserPasswordFormContainer';

export default UserPasswordFormContainer;
